import type { Vehicle } from '@/root/shared-types'

export const recordedWeightOnSail = (vehicle: Vehicle, sailRefId: number): number | null =>
  vehicle.weightOnSails?.find((entry) => entry.sailRefId === sailRefId)?.weightInKg ?? null
